import { Injectable, inject } from '@angular/core';
import { HTTP_AP_ListActivityLogs_Request } from '@api-new/reportingservice/HTTP_AP_ListActivityLogs_Request';
import { HTTP_AP_ListActivityLogs_Response } from '@api-new/reportingservice/HTTP_AP_ListActivityLogs_Response';
import { HTTP_AP_RecordActivityEvent_Request } from '@api-new/reportingservice/HTTP_AP_RecordActivityEvent_Request';
import { HTTP_CP_ActivityLog } from '@api-new/reportingservice/HTTP_CP_ActivityLog';
import { HTTP_CP_GetActivityLog_Request } from '@api-new/reportingservice/HTTP_CP_GetActivityLog_Request';
import { HTTP_CP_GetInbox_Response } from '@api-new/reportingservice/HTTP_CP_GetInbox_Response';
import { HTTP_CP_ListActivityLogs_Request } from '@api-new/reportingservice/HTTP_CP_ListActivityLogs_Request';
import { HTTP_CP_ListActivityLogs_Response } from '@api-new/reportingservice/HTTP_CP_ListActivityLogs_Response';
import { HTTP_CP_MarkInboxMessageAsRead_Request } from '@api-new/reportingservice/HTTP_CP_MarkInboxMessageAsRead_Request';
import { HTTP_CP_RecordActivityEvent_Request } from '@api-new/reportingservice/HTTP_CP_RecordActivityEvent_Request';
import { Observable } from 'rxjs';
import { ApplicationHttpClient, IRequestOptions } from '../../../../../lib/services/application-http.service';

@Injectable({ providedIn: 'root' })
export class ReportingApiService {
  private readonly httpClient = inject(ApplicationHttpClient);

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- GRPC Endpoints ----------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // Empty

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- HTTP Endpoints - Adviser Portal (ap) ------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  HTTP_AP_ListActivityLogs(
    request: HTTP_AP_ListActivityLogs_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListActivityLogs_Response> {
    return this.httpClient.post(`/reporting-service/ap/ListActivityLogs`, request, options);
  }

  HTTP_AP_RecordActivityEvent(request: HTTP_AP_RecordActivityEvent_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/reporting-service/ap/RecordActivityEvent`, request, options);
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- HTTP Endpoints - Client Portal (cp) -------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  HTTP_CP_GetActivityLog(request: HTTP_CP_GetActivityLog_Request, options?: IRequestOptions): Observable<HTTP_CP_ActivityLog> {
    return this.httpClient.get(`/reporting-service/cp/GetActivityLog`, { params: request });
  }

  HTTP_CP_GetInbox(request?: undefined, options?: IRequestOptions): Observable<HTTP_CP_GetInbox_Response> {
    return this.httpClient.get(`/reporting-service/cp/GetInbox`, { params: request });
  }

  HTTP_CP_ListActivityLogs(
    request: HTTP_CP_ListActivityLogs_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_ListActivityLogs_Response> {
    return this.httpClient.post(`/reporting-service/cp/ListActivityLogs`, request, options);
  }

  HTTP_CP_MarkInboxMessageAsRead(request: HTTP_CP_MarkInboxMessageAsRead_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/reporting-service/cp/MarkInboxMessageAsRead`, request, options);
  }

  HTTP_CP_RecordActivityEvent(request: HTTP_CP_RecordActivityEvent_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/reporting-service/cp/RecordActivityEvent`, request, options);
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- HTTP Endpoints - Extended (x) -------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // Empty

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- INIT Endpoints ----------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // Empty

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- PUBLIC Endpoints --------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  PUBLIC_UptimeCheck(request?: undefined, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.get(`/reporting-service/.public/UptimeCheck`, { params: request });
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- SPECIAL Endpoints -------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
}
